import { TypographyColor } from 'melp-design/components';
import { ClientAdminStatus } from './admin-client-admins.types';

export const COLOR_BY_STATUS: Record<ClientAdminStatus, TypographyColor> = {
  active: 'success',
  inactive: 'textSecondary',
};
